var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Cuba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M10,36h29.973c1.752-2.329,3.024-5.039,3.626-8H23.333L10,36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M23.333,20h20.265c-0.601-2.961-1.873-5.671-3.626-8H10L23.333,20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M39.973,12C36.323,7.15,30.537,4,24,4c-6.17,0-11.683,2.797-15.352,7.189L10,12H39.973z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M39.973,36H10l-1.352,0.811C12.317,41.203,17.83,44,24,44C30.537,44,36.323,40.85,39.973,36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M30,24l-6.667,4h20.265C43.861,26.707,44,25.37,44,24s-0.139-2.707-0.402-4H23.333L30,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M23.333,28L30,24l-6.667-4L10,12l-1.352-0.811C5.749,14.659,4,19.124,4,24 c0,4.876,1.749,9.341,4.648,12.811L10,36L23.333,28z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13,19l1.117,3.723h3.613l-2.922,1.84L15.926,28L13,25.875L10.074,28l1.117-3.438l-2.922-1.84h3.613 L13,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Cuba);
export default __webpack_public_path__ + "static/media/icons8-cuba.6833a70393a977e51dc0067690753f2d.svg";
export { ForwardRef as ReactComponent };